import PropTypes from 'prop-types';
import SectionImage from './SectionImage/SectionImage';
import Buttons from './Buttons/Buttons';
import classes from './SectionLayout.module.css';

const SectionLayout = ({ currentSection, nextSection, index, children }) => {
  const { name, color, previewImage: imageSrc } = currentSection;
  return (
    <div className={classes.sectionLayoutContainer}>
      <div className={classes.sectionLayout}>
        <SectionImage
          name={name}
          color={color}
          imageSrc={imageSrc[0].url}
          index={index}
        />
        <div className={classes.contentContainer}>{children}</div>
      </div>
      <Buttons nextSection={nextSection} />
    </div>
  );
};

SectionLayout.propTypes = {
  index: PropTypes.number.isRequired,
  currentSection: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    previewImage: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
      })
    ),
  }).isRequired,
  nextSection: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    previewImage: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
      })
    ),
    link: PropTypes.string,
  }),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

SectionLayout.defaultProps = {
  nextSection: undefined,
};

export default SectionLayout;
